"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createPenderAction;
/**
 * Creates a pender action
 * @param {*} actionType type of the action
 * @param {*} promiseCreator function that creates promise
 * @param {func} [metaCreator] function that creates meta
 */
function createPenderAction(actionType, promiseCreator) {
    var metaCreator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (payload) {
        return payload;
    };

    return function (payload) {

        // generate the pend and meta
        var pend = promiseCreator(payload);
        var meta = metaCreator(payload);

        return _extends({
            type: actionType,
            payload: {
                pend: pend
            }
        }, meta ? { meta: meta } : {});
    };
}

createPenderAction;


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-pender/lib/createPenderAction.js
// module id = 312
// module chunks = 1